enum FieldReportHistoryAssignmentStatus {
	INITIAL = 'INITIAL',
	REVISION = 'REVISION',
	REMOVED = 'REMOVED',
}

export default FieldReportHistoryAssignmentStatus;
